import { SVGProps } from 'react';

function MobileIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_2414_1066" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2414_1066)">
        <path d="M4.87188 15.5C4.53513 15.5 4.25008 15.3833 4.01675 15.15C3.78341 14.9166 3.66675 14.6316 3.66675 14.2948V2.70513C3.66675 2.36838 3.78341 2.08333 4.01675 1.85C4.25008 1.61667 4.53513 1.5 4.87188 1.5H11.1282C11.465 1.5 11.75 1.61667 11.9834 1.85C12.2167 2.08333 12.3334 2.36838 12.3334 2.70513V14.2948C12.3334 14.6316 12.2167 14.9166 11.9834 15.15C11.75 15.3833 11.465 15.5 11.1282 15.5L4.87188 15.5ZM8.00006 14.0128C8.16331 14.0128 8.30241 13.9553 8.41736 13.8404C8.53232 13.7254 8.5898 13.5863 8.5898 13.4231C8.5898 13.2598 8.53232 13.1207 8.41736 13.0058C8.30241 12.8908 8.16331 12.8333 8.00006 12.8333C7.83682 12.8333 7.69772 12.8908 7.58276 13.0058C7.46781 13.1207 7.41033 13.2598 7.41033 13.4231C7.41033 13.5863 7.46781 13.7254 7.58276 13.8404C7.69772 13.9553 7.83682 14.0128 8.00006 14.0128ZM4.66673 11.3462H11.3334V4.3333H4.66673V11.3462Z" fill="#868991" />
      </g>
    </svg>
  );
}

export default MobileIcon;
